<div>
  <div class="map-container">
    <evk-mapa
      (clickEnMapa)="parentEventClickEnMapa($event)"
    ></evk-mapa>
  </div>
</div>
